import React, { Component } from 'react';
import { HeaderModern, TopBar, TopHeader, Footer, Loader } from '../layouts/general';
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from '../../contexts/AuthContext';
import { API_BASE } from 'config/api';
import { alertSuccess, alertError } from '../../utils/swal';

// Convert to functional component wrapper to use hooks
const Contact01WithAuth = () => {
    const { user, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const selectedService = new URLSearchParams(location.search).get('service') || '';
    return <Contact01 user={user} isAuthenticated={isAuthenticated} navigate={navigate} selectedService={selectedService} />;
};

class Contact01 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: [
                {
                    id: 1,
                    names: 'Talk to Us',
                }
            ],
            formData: {
                name: props.user?.name || '',
                email: props.user?.email || '',
                requestedService: props.selectedService || '',
                subject: '',
                message: ''
            },
            titleheading: [
                {
                    id: '1',
                    title: 'Contact'
                }
            ],
            breadcrumbs: [
                {
                    id: 1,
                    title: 'Home',
                    classicon: 'fa fa-angle-right',
                    aria: 'true'
                },
                {
                    id: 2,
                    title: 'Contact',
                    classicon: '',
                    aria: ''
                }
            ],
            contactinfo: [
                {
                    id: '1',
                    title: 'Address',
                    info:'Dar es Salaam, Tanzania'
                },
                {
                    id: '2',
                    title: 'Phone number',
                    info:'Call us: +255 749 663 117'
                },
                {
                    id: '3',
                    title: 'E-mail address',
                    info:'info@statselite.co.tz'
                },
                {
                    id: '4',
                    title: 'Website',
                    info:'www.statselite.co.tz'
                }
            ]
        }
    }
    componentDidUpdate(prevProps) {
        // Update form data when user data becomes available
        if (this.props.user !== prevProps.user && this.props.user) {
            this.setState({
                formData: {
                    ...this.state.formData,
                    name: this.props.user.name,
                    email: this.props.user.email
                }
            });
        }
        if (this.props.selectedService !== prevProps.selectedService) {
            this.setState({
                formData: {
                    ...this.state.formData,
                    requestedService: this.props.selectedService || ''
                }
            });
        }
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            formData: {
                ...this.state.formData,
                [name]: value
            }
        });
    };

    render() {
        const { user, isAuthenticated } = this.props;

        return (
            <div className="bg-body">
                <div className="boxed">
                <Loader />
                    <TopBar />
                    <TopHeader />
                    {
                        this.state.headers.map(data => (
                            <HeaderModern data={data} key={data.id}/>
                        ))
                    }
                    <div className="page-title">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* <div className="page-title-heading">
                                        {
                                            this.state.titleheading.map(data =>(
                                                <h1 key={data.id} className="h1-title">{data.title}</h1>
                                            ))
                                        }
                                    </div>
                                    <ul className="breadcrumbs">
                                        {
                                            this.state.breadcrumbs.map(data =>(
                                                <li key={data.id} ><Link to="#" title="">{data.title}<i className={data.classicon} aria-hidden={data.aria}></i></Link></li>
                                            ))
                                        }
                                    </ul> */}
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <section className="flat-row pd-contact-v1 modern-page-section" style={{ padding: '50px 0 60px' }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="title-section center modern-section-title modern-page-title">
                                        <span className="modern-title-kicker">Contact</span>
                                        <h2>Talk to <span>Us</span></h2>
                                        <p className="sub-title-section">Tell us what you are building, measuring, or improving. We will help shape a practical next step.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'stretch', marginLeft: '-12px', marginRight: '-12px' }}>
                                {/* Contact Information card */}
                                <div className="col-md-4" style={{ padding: '0 12px', marginBottom: '24px' }}>
                                    <div
                                        style={{
                                            height: '100%',
                                            minHeight: '380px',
                                            padding: '28px 24px',
                                            backgroundColor: '#ffffff',
                                            border: '1px solid #e5e7eb',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                    >
                                        <h3 style={{
                                            fontSize: '20px',
                                            fontWeight: '700',
                                            marginBottom: '20px',
                                            color: '#1f2937',
                                            paddingBottom: '12px',
                                            borderBottom: '2px solid #62B6E8'
                                        }}>Contact Information</h3>
                                        <div style={{ flex: 1 }}>
                                            {
                                                this.state.contactinfo.map(data => (
                                                    <div key={data.id} style={{ marginBottom: '18px', display: 'flex', alignItems: 'flex-start' }}>
                                                        <span style={{
                                                            width: '36px',
                                                            height: '36px',
                                                            borderRadius: '8px',
                                                            background: '#eff6ff',
                                                            color: '#62B6E8',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            flexShrink: 0,
                                                            marginRight: '14px'
                                                        }}>
                                                            <i className={`fa ${data.id === '1' ? 'fa-map-marker' : data.id === '2' ? 'fa-phone' : data.id === '4' ? 'fa-globe' : 'fa-envelope'}`} style={{ fontSize: '14px' }}></i>
                                                        </span>
                                                        <div>
                                                            <div style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{data.title}</div>
                                                            <p style={{ fontSize: '14px', color: '#1f2937', margin: 0, lineHeight: '1.5' }}>{data.info}</p>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                            <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #e5e7eb' }}>
                                                <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '14px' }}>
                                                    <span style={{
                                                        width: '36px', height: '36px', borderRadius: '8px', background: '#eff6ff', color: '#62B6E8',
                                                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginRight: '14px'
                                                    }}><i className="fa fa-clock-o"></i></span>
                                                    <div>
                                                        <div style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Office Hours</div>
                                                        <p style={{ fontSize: '14px', color: '#1f2937', margin: 0, lineHeight: '1.5' }}>Mon–Sat: 8:00–17:00, Sunday: Closed</p>
                                                    </div>
                                                </div>
                                                <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
                                                    <a href="https://wa.me/255749663117" title="WhatsApp" target="_blank" rel="noopener noreferrer" style={{
                                                        width: '40px', height: '40px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                        background: '#f3f4f6', color: '#62B6E8', border: '1px solid #e5e7eb', textDecoration: 'none', borderRadius: '8px', transition: 'all 0.2s ease'
                                                    }} onMouseOver={e => { e.currentTarget.style.background = '#62B6E8'; e.currentTarget.style.color = '#fff'; }} onMouseOut={e => { e.currentTarget.style.background = '#f3f4f6'; e.currentTarget.style.color = '#62B6E8'; }}><i className="fa fa-whatsapp" style={{ fontSize: '18px' }}></i></a>
                                                    <a href="mailto:info@statselite.co.tz" title="Email" style={{
                                                        width: '40px', height: '40px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                        background: '#f3f4f6', color: '#62B6E8', border: '1px solid #e5e7eb', textDecoration: 'none', borderRadius: '8px', transition: 'all 0.2s ease'
                                                    }} onMouseOver={e => { e.currentTarget.style.background = '#62B6E8'; e.currentTarget.style.color = '#fff'; }} onMouseOut={e => { e.currentTarget.style.background = '#f3f4f6'; e.currentTarget.style.color = '#62B6E8'; }}><i className="fa fa-envelope" style={{ fontSize: '16px' }}></i></a>
                                                    <a href="https://linkedin.com" title="LinkedIn" target="_blank" rel="noopener noreferrer" style={{
                                                        width: '40px', height: '40px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                        background: '#f3f4f6', color: '#62B6E8', border: '1px solid #e5e7eb', textDecoration: 'none', borderRadius: '8px', transition: 'all 0.2s ease'
                                                    }} onMouseOver={e => { e.currentTarget.style.background = '#62B6E8'; e.currentTarget.style.color = '#fff'; }} onMouseOut={e => { e.currentTarget.style.background = '#f3f4f6'; e.currentTarget.style.color = '#62B6E8'; }}><i className="fa fa-linkedin" style={{ fontSize: '18px' }}></i></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Get In Touch form card */}
                                <div className="col-md-8" style={{ padding: '0 12px', marginBottom: '24px' }}>
                                    <div
                                        style={{
                                            height: '100%',
                                            minHeight: '380px',
                                            padding: '0',
                                            backgroundColor: '#ffffff',
                                            border: '1px solid #e5e7eb',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <div style={{
                                            padding: '20px 24px',
                                            background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                                            borderBottom: '1px solid #e5e7eb',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            flexWrap: 'wrap',
                                            gap: '12px'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <span style={{ width: '40px', height: '40px', borderRadius: '8px', background: '#62B6E8', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <i className="fa fa-envelope" style={{ fontSize: '16px' }}></i>
                                                </span>
                                                <h3 style={{ fontSize: '18px', fontWeight: '700', margin: 0, color: '#1f2937' }}>Get In Touch</h3>
                                            </div>
                                            {isAuthenticated && user && (
                                                <span style={{ background: 'rgba(98, 182, 232, 0.15)', padding: '6px 12px', borderRadius: '6px', fontSize: '13px', color: '#2F7FAE', fontWeight: '500' }}>
                                                    <i className="fa fa-user-circle" style={{ marginRight: '6px' }}></i>{user.name}
                                                </span>
                                            )}
                                        </div>
                                        <div style={{ padding: '24px' }}>
                                            <p style={{ fontSize: '14px', color: '#4b5563', marginBottom: '20px', lineHeight: '1.6' }}>
                                                {isAuthenticated
                                                    ? 'You are logged in. Your information has been pre-filled. Send us a message and we\'ll respond as soon as possible.'
                                                    : 'We\'d love to hear from you. Send us a message and we\'ll respond as soon as possible.'}
                                            </p>
                                            <form id="contactform" noValidate="novalidate" className="form-info" onSubmit={async (e) => {
                                                e.preventDefault();
                                                const payload = {
                                                    name: this.state.formData.name,
                                                    email: this.state.formData.email,
                                                    subject: this.state.formData.subject,
                                                    requestedService: this.state.formData.requestedService,
                                                    message: this.state.formData.message,
                                                    userId: user?.id || null
                                                };
                                                try {
                                                    const headers = { 'Content-Type': 'application/json' };
                                                    if (user?.token) {
                                                        headers['Authorization'] = `Bearer ${user.token}`;
                                                    }

                                                    const res = await fetch(`${API_BASE}/contact`, {
                                                        method: 'POST',
                                                        headers,
                                                        body: JSON.stringify(payload)
                                                    });
                                                    const data = await res.json();
                                                    if (!res.ok) {
                                                        throw new Error(data.message || 'Server error');
                                                    }
                                                    alertSuccess('Message sent', data.message || 'Your message has been sent.');
                                                    this.setState({
                                                        formData: {
                                                            name: user?.name || '',
                                                            email: user?.email || '',
                                                            requestedService: this.state.formData.requestedService,
                                                            subject: '',
                                                            message: ''
                                                        }
                                                    });
                                                } catch (err) {
                                                    alertError('Failed to send', err.message || 'Please try again.');
                                                }
                                            }}>
                                                <div className="row" style={{ marginLeft: '-8px', marginRight: '-8px' }}>
                                                    <div className="col-md-6" style={{ padding: '0 8px' }}>
                                                        <div className="form-group" style={{ marginBottom: '16px' }}>
                                                            <label htmlFor="name" style={{
                                                                display: 'block',
                                                                marginBottom: '5px',
                                                                fontSize: '13px',
                                                                fontWeight: '500',
                                                                color: '#1f2937'
                                                            }}>Your Name *</label>
                                                            <input
                                                                type="text"
                                                                name="name"
                                                                id="name"
                                                                value={this.state.formData.name}
                                                                onChange={this.handleInputChange}
                                                                placeholder="Enter your full name"
                                                                required="required"
                                                                readOnly={isAuthenticated}
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '10px 12px',
                                                                    border: '1px solid #e0e0e0',
                                                                    borderRadius: '0',
                                                                    fontSize: '13px',
                                                                    transition: 'all 0.3s ease',
                                                                    background: isAuthenticated ? '#f0f0f0' : '#fafafa',
                                                                    cursor: isAuthenticated ? 'not-allowed' : 'text'
                                                                }}
                                                                onFocus={(e) => {
                                                                    if (!isAuthenticated) {
                                                                        e.target.style.borderColor = '#62B6E8';
                                                                        e.target.style.boxShadow = '0 0 0 3px rgba(98, 182, 232, 0.1)';
                                                                        e.target.style.background = '#fff';
                                                                    }
                                                                }}
                                                                onBlur={(e) => {
                                                                    if (!isAuthenticated) {
                                                                        e.target.style.borderColor = '#e0e0e0';
                                                                        e.target.style.boxShadow = 'none';
                                                                        e.target.style.background = '#fafafa';
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6" style={{ padding: '0 8px' }}>
                                                        <div className="form-group" style={{ marginBottom: '16px' }}>
                                                            <label htmlFor="email" style={{
                                                                display: 'block',
                                                                marginBottom: '5px',
                                                                fontSize: '13px',
                                                                fontWeight: '500',
                                                                color: '#1f2937'
                                                            }}>Email Address *</label>
                                                            <input
                                                                type="email"
                                                                name="email"
                                                                id="email"
                                                                value={this.state.formData.email}
                                                                onChange={this.handleInputChange}
                                                                placeholder="your.email@example.com"
                                                                required="required"
                                                                readOnly={isAuthenticated}
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '10px 12px',
                                                                    border: '1px solid #e0e0e0',
                                                                    borderRadius: '0',
                                                                    fontSize: '13px',
                                                                    transition: 'all 0.3s ease',
                                                                    background: isAuthenticated ? '#f0f0f0' : '#fafafa',
                                                                    cursor: isAuthenticated ? 'not-allowed' : 'text'
                                                                }}
                                                                onFocus={(e) => {
                                                                    if (!isAuthenticated) {
                                                                        e.target.style.borderColor = '#62B6E8';
                                                                        e.target.style.boxShadow = '0 0 0 3px rgba(98, 182, 232, 0.1)';
                                                                        e.target.style.background = '#fff';
                                                                    }
                                                                }}
                                                                onBlur={(e) => {
                                                                    if (!isAuthenticated) {
                                                                        e.target.style.borderColor = '#e0e0e0';
                                                                        e.target.style.boxShadow = 'none';
                                                                        e.target.style.background = '#fafafa';
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12" style={{ padding: '0 8px' }}>
                                                        {this.state.formData.requestedService && (
                                                            <div className="form-group" style={{ marginBottom: '16px' }}>
                                                                <label htmlFor="requestedService" style={{
                                                                    display: 'block',
                                                                    marginBottom: '5px',
                                                                    fontSize: '13px',
                                                                    fontWeight: '500',
                                                                    color: '#1f2937'
                                                                }}>Requested Service</label>
                                                                <input
                                                                    type="text"
                                                                    name="requestedService"
                                                                    id="requestedService"
                                                                    value={this.state.formData.requestedService}
                                                                    readOnly
                                                                    style={{
                                                                        width: '100%',
                                                                        padding: '10px 12px',
                                                                        border: '1px solid #e0e0e0',
                                                                        borderRadius: '0',
                                                                        fontSize: '13px',
                                                                        transition: 'all 0.3s ease',
                                                                        background: '#f0f9ff',
                                                                        color: '#1f2937'
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        <div className="form-group" style={{ marginBottom: '16px' }}>
                                                            <label htmlFor="subject" style={{
                                                                display: 'block',
                                                                marginBottom: '5px',
                                                                fontSize: '13px',
                                                                fontWeight: '500',
                                                                color: '#1f2937'
                                                            }}>Subject *</label>
                                                            <input
                                                                type="text"
                                                                name="subject"
                                                                id="subject"
                                                                value={this.state.formData.subject}
                                                                onChange={this.handleInputChange}
                                                                placeholder="How can we help you?"
                                                                required="required"
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '10px 12px',
                                                                    border: '1px solid #e0e0e0',
                                                                    borderRadius: '0',
                                                                    fontSize: '13px',
                                                                    transition: 'all 0.3s ease',
                                                                    background: '#fafafa'
                                                                }}
                                                                onFocus={(e) => {
                                                                    e.target.style.borderColor = '#62B6E8';
                                                                    e.target.style.boxShadow = '0 0 0 3px rgba(98, 182, 232, 0.1)';
                                                                    e.target.style.background = '#fff';
                                                                }}
                                                                onBlur={(e) => {
                                                                    e.target.style.borderColor = '#e0e0e0';
                                                                    e.target.style.boxShadow = 'none';
                                                                    e.target.style.background = '#fafafa';
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12" style={{ padding: '0 8px' }}>
                                                        <div className="form-group" style={{ marginBottom: '16px' }}>
                                                            <label htmlFor="message" style={{
                                                                display: 'block',
                                                                marginBottom: '5px',
                                                                fontSize: '13px',
                                                                fontWeight: '500',
                                                                color: '#1f2937'
                                                            }}>Message *</label>
                                                            <textarea
                                                                id="message-contact"
                                                                name="message"
                                                                value={this.state.formData.message}
                                                                onChange={this.handleInputChange}
                                                                placeholder="Tell us more about your project or question..."
                                                                required="required"
                                                                rows="3"
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '8px 12px',
                                                                    border: '1px solid #e0e0e0',
                                                                    borderRadius: '0',
                                                                    fontSize: '13px',
                                                                    resize: 'vertical',
                                                                    height: '120px',
                                                                    minHeight: '80px',
                                                                    fontFamily: 'inherit',
                                                                    lineHeight: '1.5',
                                                                    transition: 'all 0.3s ease',
                                                                    background: '#fafafa'
                                                                }}
                                                                onFocus={(e) => {
                                                                    e.target.style.borderColor = '#62B6E8';
                                                                    e.target.style.boxShadow = '0 0 0 3px rgba(98, 182, 232, 0.1)';
                                                                    e.target.style.background = '#fff';
                                                                }}
                                                                onBlur={(e) => {
                                                                    e.target.style.borderColor = '#e0e0e0';
                                                                    e.target.style.boxShadow = 'none';
                                                                    e.target.style.background = '#fafafa';
                                                                }}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12" style={{ padding: '0 8px' }}>
                                                        <div className="form-submit" style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '8px' }}>
                                                            <button
                                                                type="submit"
                                                                className="submit"
                                                                style={{
                                                                    padding: '10px 35px',
                                                                    backgroundColor: '#62B6E8',
                                                                    color: '#fff',
                                                                    border: '2px solid #62B6E8',
                                                                    borderRadius: '0',
                                                                    fontSize: '13px',
                                                                    fontWeight: '600',
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.3s ease',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.5px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    textAlign: 'center'
                                                                }}
                                                                onMouseOver={(e) => {
                                                                    e.target.style.backgroundColor = '#2F7FAE';
                                                                    e.target.style.borderColor = '#2F7FAE';
                                                                    e.target.style.transform = 'translateY(-2px)';
                                                                }}
                                                                onMouseOut={(e) => {
                                                                    e.target.style.backgroundColor = '#62B6E8';
                                                                    e.target.style.borderColor = '#62B6E8';
                                                                    e.target.style.transform = 'translateY(0)';
                                                                }}
                                                            >
                                                                Send Message
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                            <div style={{ marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
                                                <p style={{ textAlign: 'center', fontSize: '12px', color: '#6b7280', margin: 0 }}>
                                                    <i className="fa fa-lock" style={{ marginRight: '6px', color: '#62B6E8' }}></i>
                                                    Your information is secure and will never be shared with third parties.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>

        <section className="flat-row pdmap" style={{padding: '0', margin: '0'}}>
            <div className="container-fluid" style={{padding: '0', margin: '0'}}>
                <div style={{
                    width: '100%',
                    height: '500px',
                    backgroundColor: '#f5f5f5',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    <iframe
                        src="https://maps.google.com/maps?output=embed&q=current+location&t=m&z=15"
                        width="100%"
                        height="100%"
                        style={{border: '0'}}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Map showing your current location"
                    ></iframe>
                </div>
            </div>
        </section>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default Contact01WithAuth;
